import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { GenerateInputType } from '@/stores/type/generateInput.type'

const { api } = useApi()

const baseUrl = API.GENERATE_INPUT.INDEX
const getGenerateInputDetail = API.GENERATE_INPUT.GET_GENERATE_INPUT_DETAIL

export const useGenerateInputStore = defineStore('generateInput', () => {
  const items = ref<GenerateInputType[]>([])
  const currentItem = ref<GenerateInputType | undefined>()

  const getCurrentGenerateInput = computed(() => currentItem.value)

  async function fetchGenerateInputs(calculation: number) {
    try {
      const response = await api.service(getGenerateInputDetail(calculation)).get()
      items.value = response
      currentItem.value = response
    } catch (error) {
      console.error('Error fetching generate inputs:', error)
    }
  }

  async function createGenerateInput(simulation: number, geometry: object) {
    try {
      const response = await api.service(baseUrl).post({
        simulation,
        geometry
      })
      return response.data
    } catch (error) {
      console.error('Error creating generate input:', error)
      throw error
    }
  }

  async function updateGenerateInputGeometry(
    generateInputId: number,
    simulation: number,
    geometry: object
  ) {
    try {
      const response = await api.service(baseUrl).patch(generateInputId, {
        simulation,
        geometry
      })
      return response.data
    } catch (error) {
      console.error('Error updating generate input geometry:', error)
      throw error
    }
  }

  function resetAll() {
    items.value = []
    currentItem.value = undefined
  }

  return {
    items,
    currentItem,
    getCurrentGenerateInput,
    fetchGenerateInputs,
    createGenerateInput,
    updateGenerateInputGeometry,
    resetAll
  }
})
